import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const BuildingIcon: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    viewBox="0 0 53 53"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.37292 48.0312H31.3679V4.96875L6.37292 16.1088V48.0312Z"
      fill="#FF612B"
    />
    <path d="M46.627 10.492H32.7721V48.0312H46.627V10.492Z" fill="#002677" />
    <path d="M13.394 41.1038H9.1814V48.0313H13.394V41.1038Z" fill="#FF612B" />
    <path
      d="M39.6996 41.1038H35.4869V48.0313H39.6996V41.1038Z"
      fill="#FF612B"
    />
    <path d="M28.6532 20.2279H9.1814V23.0364H28.6532V20.2279Z" fill="#ffffff" />
    <path d="M28.6532 27.1553H9.1814V29.9638H28.6532V27.1553Z" fill="#ffffff" />
    <path d="M28.6532 34.1764H9.1814V36.9848H28.6532V34.1764Z" fill="#ffffff" />
    <path
      d="M38.2954 20.2279H35.4869V23.0364H38.2954V20.2279Z"
      fill="#ffffff"
    />
    <path
      d="M43.9123 20.2279H41.1039V23.0364H43.9123V20.2279Z"
      fill="#ffffff"
    />
    <path
      d="M43.9123 13.3005H41.1039V16.1089H43.9123V13.3005Z"
      fill="#ffffff"
    />
    <path
      d="M43.9123 34.1764H41.1039V36.9848H43.9123V34.1764Z"
      fill="#ffffff"
    />
    <path
      d="M38.2954 27.1553H35.4869V29.9638H38.2954V27.1553Z"
      fill="#ffffff"
    />
    <path
      d="M38.2954 34.1764H35.4869V36.9848H38.2954V34.1764Z"
      fill="#ffffff"
    />
  </Box>
)

export default BuildingIcon
